export const CSD_MESSAGES = {
  1: {
    color: '#979797',
    message: 'Informational',
  },
  2: {
    color: '#00a5eb',
    message: 'Minor',
  },
  3: {
    color: '#fff629',
    message: 'Moderate',
  },
  4: {
    color: '#fdb022',
    message: 'Urgent',
  },
  5: {
    color: '#f04438',
    message: 'Critical',
  },
} as const;

export const CSD_COLOR_VARIANTS = {
  '#00a5eb': { border: 'border-[#00a5eb]', text: 'text-[#00a5eb]' },
  '#979797': { border: 'border-[#979797]', text: 'text-[#979797]' },
  '#f04438': { border: 'border-[#f04438]', text: 'text-[#f04438]' },
  '#fdb022': { border: 'border-[#fdb022]', text: 'text-[#fdb022]' },
  '#fff629': { border: 'border-[#fff629]', text: 'text-[#fff629]' },
} as const;

export const CSD_TOOLTIP_MESSAGES = {
  1: 'Informational only and not clinically significant.',
  2: 'Unlikely to be clinically significant and no additional evaluation is typically needed.',
  3: 'May be clinically significant and should be reviewed by a healthcare clinician.',
  4: 'Concerning and requires prompt medical evaluation.',
  5: 'Highly concerning and requires expedited medical evaluation.',
} as const;
